import { Parallax } from "react-scroll-parallax";
import TextCont from "./components/text.js";
import downloadFile from "./components/file.js";
import Timeline from "./components/Timeline.js";
import Footer from "./components/Footer.js";

// Helper function to handle download
const handleDownloadClick = (event) => {
  event.preventDefault();
  downloadFile(
    "./cv_file/CV_VALTTERI_PUUMALAINEN.pdf",
    "CV_VALTTERI_PUUMALAINEN.pdf"
  );
};

// Main App component
function App() {
  const heroMotion = {
    translateY: [0, -220],
    opacity: [1, 0.15],
    easing: "easeOutCubic",
    startScroll: 0,
    endScroll: 1200
  };

  return (
    <div className="App">
      <div id="background" aria-hidden="true"></div>
      <div id="logo-wrap" aria-hidden="true">
        <Parallax {...heroMotion}>
          <div id="logo"></div>
        </Parallax>
      </div>
      <div id="buttons-wrap">
        <Parallax {...heroMotion}>
          <div id="buttons">
            <a
              href="https://www.linkedin.com/in/puuval/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img src="./images/linkedin.png" alt="LinkedIn" />
            </a>
            <a
              href="https://github.com/puuval"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img src="./images/github.png" alt="GitHub" />
            </a>
            <a href="#" onClick={handleDownloadClick}>
              <img src="./images/download.png" alt="Download" />
            </a>
          </div>
        </Parallax>
      </div>
      <div id="hero-spacer" aria-hidden="true"></div>
      <TextCont />
      <Timeline />
      <Footer />
    </div>
  );
}

export default App;